import React from "react"
import { VariantReader } from "aldoo-ra/VariantReader"
import { twMerge } from "tailwind-merge"

export default function Breadcrumbs({
  items = [],
  variant = "primary",
  styleOverrides,
  className = "",
  separatorIcon: SeparatorIcon,
  onItemClick,
}) {
  const variants = VariantReader.useVariant({
    componentName: "Breadcrumbs",
    variant,
    styleOverrides,
  })

  if (!items || items.length === 0) {
    return null
  }

  const handleItemClick = (item, index) => {
    if (onItemClick && typeof onItemClick === 'function') {
      onItemClick(item, index)
    } else if (item.onClick && typeof item.onClick === 'function') {
      item.onClick(item, index)
    }
  }

  return (
    <nav className={twMerge(variants.container, className)} aria-label="Breadcrumb">
      <ol className={variants.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          const isClickable = !isLast && (item.onClick || onItemClick) && !item.disabled

          return (
            <li key={index} className={variants.item}>
              <div className={variants.itemContent}>
                {/* Item content */}
                {isClickable ? (
                  <button
                    onClick={() => handleItemClick(item, index)}
                    className={twMerge(
                      variants.link,
                      item.className
                    )}
                    disabled={item.disabled}
                  >
                    {item.icon && (
                      <span className={variants.icon}>
                        {React.isValidElement(item.icon) ? item.icon : <item.icon className="w-4 h-4" />}
                      </span>
                    )}
                    {item.label || item.text || item.name}
                  </button>
                ) : (
                  <span
                    className={twMerge(
                      isLast ? variants.current : variants.text,
                      item.className
                    )}
                  >
                    {item.icon && (
                      <span className={variants.icon}>
                        {React.isValidElement(item.icon) ? item.icon : <item.icon className="w-4 h-4" />}
                      </span>
                    )}
                    {item.label || item.text || item.name}
                  </span>
                )}

                {/* Separator */}
                {!isLast && (
                  <span className={variants.separator}>
                    {SeparatorIcon ? (
                      <SeparatorIcon className={variants.separatorIcon} />
                    ) : (
                      <svg
                        className={variants.separatorIcon}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </span>
                )}
              </div>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}